import { Link } from 'react-router-dom';
import { HomeOutlined, DiffOutlined, EditOutlined, ProjectOutlined, UserAddOutlined, ToolOutlined } from '@ant-design/icons';

function getItem(label, key, icon, children, type) {
  return {
    label,
    key,
    icon,
    children,
    type
  }
}

const items = [
  getItem(<Link to='/layout/home'>home</Link>, '/layout/home', <HomeOutlined/>),
  getItem(<Link to='/layout/order'>Order</Link>, '/layout/order', <ProjectOutlined />),
  getItem(<Link to='/layout/qoute'>Qoute</Link>, '/layout/qoute', <DiffOutlined/>),
  getItem(<Link to='/layout/setting'>Setting</Link>, '/layout/setting', <EditOutlined/>),
]

const generateItems =  (userInfo) => {
  if (parseInt(userInfo.role, 10) === 0) {
    return [
      ...items,
      getItem(<Link to='/layout/account'>Account</Link>, '/layout/account', <UserAddOutlined />),
      getItem(<Link to='/layout/manage'>manage</Link>, '/layout/manage', <ToolOutlined />)
    ]
  }
  
  return items
}



export default generateItems;